export async function payWithRevolut({ token, mode }, { onSuccess, onError, save = false }) {
  if (!token) throw new Error("Aucun jeton de paiement reçu");
  const mod = await import("@revolut/checkout");
  const RC = mod.default || mod.RevolutCheckout;
  const rc = await RC(token, mode === "production" ? "prod" : "sandbox");
  rc.payWithPopup({ ...(save ? { savePaymentMethodFor: "merchant" } : {}), onSuccess, onError });
}

export const euro = (v) => `${Number(v || 0).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} €`;
